module.exports = __webpack_public_path__ + "img/9788958072805.2fe08cac.jpg";